import React, {useRef} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import usePortfolio from "../../hooks/usePortfolio";

function Header() {
  const menuCheckboxRef = useRef(null);
  const {greeting, workExperiences, skillsSection, educationInfo, bigProjects, openSource, blogSection, talkSection, achievementSection, contactInfo} = usePortfolio();
  const viewExperience = workExperiences.display;
  const viewEducation = educationInfo.display;
  const viewProjects = bigProjects.display;
  const viewOpenSource = openSource.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;
  const viewBlog = blogSection.display;
  const viewTalks = talkSection.display;

  const closeMenu = () => {
    if (menuCheckboxRef.current) {
      menuCheckboxRef.current.checked = false;
    }
  };

  return (
    <Headroom disable={false} pin={true} upTolerance={10} downTolerance={10}>
      <header className="dark-menu header">
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </a>
        <input 
          ref={menuCheckboxRef}
          className="menu-btn" 
          type="checkbox" 
          id="menu-btn" 
        />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className="navicon navicon-dark"></span>
        </label>
        <ul className="dark-menu menu">
          {viewSkills && (
            <li>
              <a href="#skills" onClick={closeMenu}>{skillsSection.linkName}</a>
            </li>
          )}
          {viewExperience && (
            <li>
              <a href="#experience" onClick={closeMenu}>{workExperiences.linkName}</a>
            </li>
          )}
          {viewEducation && (
            <li>
              <a href="#education" onClick={closeMenu}>{educationInfo.linkName}</a>
            </li>
          )}
          {viewProjects && (
            <li>
              <a href="#projects" onClick={closeMenu}>{bigProjects.linkName}</a>
            </li>
          )}
          {viewOpenSource && (
            <li>
              <a href="#opensource" onClick={closeMenu}>{openSource.linkName}</a>
            </li>
          )}
          {viewAchievement && (
            <li>
              <a href="#achievements" onClick={closeMenu}>{achievementSection.linkName}</a>
            </li>
          )}
          {viewBlog && (
            <li>
              <a href="#blogs" onClick={closeMenu}>{blogSection.linkName}</a>
            </li>
          )}
          {viewTalks && (
            <li>
              <a href="#talks" onClick={closeMenu}>{talkSection.linkName}</a>
            </li>
          )}
          <li>
            <a href="#contact" onClick={closeMenu}>{contactInfo.linkName}</a>
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
